export const SET_HIGHLIGHT = 'nav/SET_HIGHLIGHT';
export const RESPONSE_NAV = 'nav/RESPONSE_NAVDATA';
export const NODE_SELECTED = 'nav/NODE_SELECTED';
export const SET_SECONDMENU_NAVITEMS = 'SET_SECONDMENU_NAVITEMS';
export const SET_SECONDMENU_VISIBILITY = 'SET_SECONDMENU_VISIBILITY';
export const SET_SECONDMENU_CURRENT_SELECTED = 'SET_SECONDMENU_CURRENT_SELECTED';
export const SET_SECONDMENU_SUBITEM_SELECTED = 'SET_SECONDMENU_SUBITEM_SELECTED';
export const SET_TEMPORARY_MAIN_SELECTED = 'SET_TEMPORARY_MAIN_SELECTED';
export const SET_NAVIGATION_PARAMS = 'SET_NAVIGATION_PARAMS';
